import { ClassRequestModel, QuestionBankViewReq, QuestionsCountModel, SubjectClassReqModel } from "@boi/shared-models";
import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Chapter } from "../../entities/chapter";
import { ClassEntity } from "../../entities/class";
import { LanguageEntity } from "../../entities/language";
import { Subject } from "../../entities/subject";
import { CreateQuestion } from "../entities/create-question";

import * as moment from 'moment';
import { Console } from "console";

@Injectable()
export class CreateQuestionRepo extends Repository<CreateQuestion> {
    constructor(private dataSource: DataSource) {
        super(CreateQuestion, dataSource.createEntityManager());
    }

    async getAllQuestionBankData(req: QuestionBankViewReq) {
        const classData = this.createQueryBuilder('cq')
            .select(`cq.id as id ,cq.qno,cq.marks,cq.question,class.class as className,cq.qtype as difficulty, cq.complexity as complexity, sub.subject,chapter.chapter,language.language,cq.is_active as isActive`)
            .leftJoin(ClassEntity, 'class', 'class.id = cq.class')
            .leftJoin(Subject, 'sub', 'sub.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=cq.language')
            .leftJoin(Chapter, 'chapter', 'chapter.id=cq.chapter')
            .where(`cq.class = '${req.classId}'`)
            .andWhere('cq.is_active = :active', { active: 1 })
        if (req.marks) {
            classData.andWhere(`cq.marks='${req.marks}'`)
        }
        if (req.language) {
            classData.andWhere(`cq.language='${req.language}'`)
        }
        if (req.subject) {
            classData.andWhere(`cq.subject='${req.subject}'`)
        }
        if (req.chapter) {
            classData.andWhere(`cq.chapter='${req.chapter}'`)
        }
        if (req.activeOnly) {
            classData.andWhere(`cq.is_active='${req.activeOnly ? 1 : 0}'`)
        }
        classData.orderBy('cq.qno')
        const data = await classData.getRawMany();
        console.log(data)
        return data;
    }
    async getQuestionSubjectPivot(req: ClassRequestModel) {
        const res: any[] = await this.createQueryBuilder('cq')
            .select(`
                s.id, 
                s.subject,
                 language.language,
                 class.class as className,
                 COUNT(1) as totalQuestions,
                 SUM(CASE WHEN cq.is_active = 1 THEN 1 ELSE 0 END) as activeQuestions,
                SUM(CASE WHEN cq.is_active = 0 THEN 1 ELSE 0 END) as inActiveQuestions
            `)
            .leftJoin(ClassEntity, 'class', 'class.id=cq.class')
            .leftJoin(Subject, 's', 's.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`cq.class = '${req.classId}'`)
            .groupBy(`cq.class,cq.subject`)
            .getRawMany();
        return res;
    }



    async getQuestionsCountSummery(req: ClassRequestModel): Promise<QuestionsCountModel> {
        const oneMonthAgo = moment().subtract(1, 'months').toISOString();
        const oneWeekAgo = moment().subtract(1, 'weeks').toISOString();
        const lastMonth = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions`)
            .where('cq.timestamp >= :startDate', { startDate: oneMonthAgo })
            .andWhere(`cq.class = '${req.classId}'`)
            .getRawOne();
        const lastWeek = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions`)
            .where('cq.timestamp >= :startDate', { startDate: oneWeekAgo })
            .andWhere(`cq.class = '${req.classId}'`)
            .getRawOne();
        const total = await this.createQueryBuilder('cq')
            .select(`COUNT(1) as totalQuestions,
             SUM(CASE WHEN cq.is_active = 1 THEN 1 ELSE 0 END) as activeQuestions,
            SUM(CASE WHEN cq.is_active = 0 THEN 1 ELSE 0 END) as inActiveQuestions`)
            .where(`cq.class = '${req.classId}'`)
            .getRawOne();
        return new QuestionsCountModel(total.totalQuestions, lastMonth.totalQuestions, lastWeek.totalQuestions, total.activeQuestions, total.inActiveQuestions);
    }

    async getAllQuestionsCountsBySubject(req: SubjectClassReqModel) {
        const subjectName: any = await this.dataSource.createQueryBuilder()
            .select('s.subject as subject')
            .from(Subject, 's')
            .where(`s.id = "${req.subject}"`)
            .getRawOne()
        console.log(subjectName)
        const subjectIds: any = this.dataSource.createQueryBuilder()
            .select('s.id')
            .from(Subject, 's')
            .where(`s.subject = "${subjectName.subject}"`)
        const res: any[] = await this.createQueryBuilder('cq')
            .select(`language.language,s.subject`)
            .addSelect('COUNT(*)', 'totalQuestions')
            .leftJoin(ClassEntity, 'class', 'class.id=cq.class')
            .leftJoin(Subject, 's', 's.id=cq.subject')
            .leftJoin(LanguageEntity, 'language', 'language.id=s.language')
            .where(`cq.class = '${req.classId}' and cq.subject IN (${subjectIds.getQuery()})`)
            .groupBy(`language.language,s.subject`)
            .getRawMany();
        return res;
    }



    // async GetSingleQuestionBankData(req: QuestionBankViewReq) {
    //     const query = this.dataSource
    //         .createQueryBuilder()
    //         .select([
    //             'cq_en.id AS id',
    //             'cq_en.qno AS qno',
    //             'cq_en.qno AS qno_en',
    //             'cq_te.qno AS qno_te',
    //             'cq_ur.qno AS qno_ur',
    //             'cq_en.marks AS marks',
    //             'cq_en.question AS question_en',
    //             'cq_te.question AS question_te',
    //             'cq_ur.question AS question_ur',
    //             'c.class AS className',
    //             's_en.subject AS subject_en',
    //             's_te.subject AS subject_te',
    //             's_ur.subject AS subject_ur',
    //             'ch_en.chapter AS chapter_en',
    //             'ch_te.chapter AS chapter_te',
    //             'ch_ur.chapter AS chapter_ur',
    //             'l.language AS language',
    //             'cq_en.is_active AS isActive',
    //         ])
    //         .from('createquestion', 'cq_en')

    //         .leftJoin('class', 'c', 'c.id = cq_en.class')
    //         .leftJoin('subject', 's_en', 's_en.id = cq_en.subject')
    //         .leftJoin('chapter', 'ch_en', 'ch_en.id = cq_en.chapter')
    //         .leftJoin('language', 'l', 'l.id = cq_en.language')

    //         .leftJoin('subject', 's_te',
    //             `s_te.subject_parent_id = s_en.id 
    //          AND s_te.language = (SELECT id FROM language WHERE language='TELUGU')`
    //         )
    //         .leftJoin('chapter', 'ch_te',
    //             'ch_te.chapter_parent_id = ch_en.id AND ch_te.subject = s_te.id'
    //         )
    //         .leftJoin('createquestion', 'cq_te',
    //             'cq_te.qno = cq_en.qno AND cq_te.subject = s_te.id AND cq_te.chapter = ch_te.id'
    //         )

    //         .leftJoin('subject', 's_ur',
    //             `s_ur.subject_parent_id = s_en.id 
    //          AND s_ur.language = (SELECT id FROM language WHERE language='URDU')`
    //         )
    //         .leftJoin('chapter', 'ch_ur',
    //             'ch_ur.chapter_parent_id = ch_en.id AND ch_ur.subject = s_ur.id'
    //         )
    //         .leftJoin('createquestion', 'cq_ur',
    //             'cq_ur.qno = cq_en.qno AND cq_ur.subject = s_ur.id AND cq_ur.chapter = ch_ur.id'
    //         )

    //         .orderBy('cq_en.qno', 'ASC');

    //     if (req.classId) {
    //         query.andWhere('cq_en.class = :classId', { classId: req.classId });
    //     }

    //     if (req.subject) {
    //         query.andWhere('cq_en.subject = :subjectId', { subjectId: req.subject });
    //     }

    //     if (req.chapter) {
    //         query.andWhere('cq_en.chapter = :chapterId', { chapterId: req.chapter });
    //     }

    //     if (req.marks) {
    //         query.andWhere('cq_en.marks = :marks', { marks: req.marks });
    //     }

    //     if (req.language) {
    //         query.andWhere('l.language = :language', { language: req.language });
    //     } else {
    //         query.andWhere("l.language = 'ENGLISH'");
    //     }

    //     if (req.activeOnly !== undefined) {
    //         query.andWhere('cq_en.is_active = :activeOnly', { activeOnly: req.activeOnly ? 1 : 0 });
    //     }

    //     const res = await query.getRawMany();
    //     console.log('QuestionBankData ---->', res);
    //     return res;
    // }


    async GetSingleQuestionBankData(req: QuestionBankViewReq) {

        let sql = `
        SELECT 
            cq_en.id,
            cq_en.qno,
            cq_en.qno AS qno_en,
             cq_en.id AS question_en_id,
            cq_te.qno AS qno_te,
             cq_te.id AS question_te_id,
            cq_ur.qno AS qno_ur,
              cq_ur.id AS question_ur_id,
            cq_en.marks,
            cq_ur.qtype as difficulty,
            cq_ur.complexity as complexity,
            cq_en.question AS question_en,
            cq_te.question AS question_te,
            cq_ur.question AS question_ur,
            c.class AS className,
            s_en.id AS subject_id,
            s_en.subject AS subject_en,
            s_te.subject AS subject_te,
            s_ur.subject AS subject_ur,
            ch_en.id AS chapter_id,
            ch_en.chapter AS chapter_en,
            ch_te.chapter AS chapter_te,
            ch_ur.chapter AS chapter_ur,
            l.language AS language,
            cq_en.is_active AS isActive
        FROM createquestion cq_en
        LEFT JOIN class c ON c.id = cq_en.class
        LEFT JOIN subject s_en ON s_en.id = cq_en.subject
        LEFT JOIN chapter ch_en ON ch_en.id = cq_en.chapter
        LEFT JOIN language l ON l.id = cq_en.language
        LEFT JOIN subject s_te 
            ON s_te.subject_parent_id = s_en.id 
            AND s_te.language = (SELECT id FROM language WHERE language='TELUGU')
        LEFT JOIN chapter ch_te 
            ON ch_te.chapter_parent_id = ch_en.id AND ch_te.subject = s_te.id
        LEFT JOIN createquestion cq_te 
            ON cq_te.qno = cq_en.qno AND cq_te.subject = s_te.id AND cq_te.chapter = ch_te.id
        LEFT JOIN subject s_ur 
            ON s_ur.subject_parent_id = s_en.id 
            AND s_ur.language = (SELECT id FROM language WHERE language='URDU')
        LEFT JOIN chapter ch_ur 
            ON ch_ur.chapter_parent_id = ch_en.id AND ch_ur.subject = s_ur.id
        LEFT JOIN createquestion cq_ur 
            ON cq_ur.qno = cq_en.qno AND cq_ur.subject = s_ur.id AND cq_ur.chapter = ch_ur.id
        WHERE 1 = 1
    `;

        const params: any[] = [];

        if (req.classId) {
            sql += ` AND cq_en.class = ?`;
            params.push(req.classId);
        }
        if (req.subject) {
            sql += ` AND cq_en.subject = ?`;
            params.push(req.subject);
        }
        if (req.chapter) {
            sql += ` AND cq_en.chapter = ?`;
            params.push(req.chapter);
        }
        if (req.marks) {
            sql += ` AND cq_en.marks = ?`;
            params.push(req.marks);
        }

        const subject = (req.subjectName || '').toUpperCase();

        if (subject.includes('TELUGU')) {
            // console.log('telllllll');
            sql += ` AND l.language = 'TELUGU'`;
        } else if (subject.includes('ENGLISH')) {
            console.log('engggggg');
            sql += ` AND l.language = 'ENGLISH'`;
        } else if (subject.includes('SANSKRIT')) {
            // console.log('snassssssssssss');
            sql += ` AND l.language = 'SANSKRIT'`;
        } else if (subject.includes('HINDI')) {
            // console.log('hindddddddddd');
            sql += ` AND l.language = 'HINDI'`;
        } else if (subject.includes('URDU')) {
            // console.log('urduuuuuuuuu');
            sql += ` AND l.language = 'URDU'`;
        } else {
            console.log(';;;;;;;;;;;;;;;;;;');
            // sql += ` AND l.language = ?`;
            sql += ` AND l.language = 'ENGLISH'`;
            params.push(req.language);
        }

        // if (req.language) {
        //     sql += ` AND l.language = ?`;
        //     params.push(req.language);
        // } else {
        //     sql += ` AND l.language = 'ENGLISH'`;
        // }
        if (req.activeOnly !== undefined) {
            sql += ` AND cq_en.is_active = ?`;
            params.push(req.activeOnly ? 1 : 0);
        }

        sql += ` ORDER BY cq_en.qno ASC`;

        const res = await this.dataSource.query(sql, params);
        // console.log('QuestionBankData ---->', res);
        return res;
    }

    async getMaxQnoBySubject(req: SubjectClassReqModel) {
        const res: any = await this.createQueryBuilder('cq')
            .select('MAX(cq.qno)', 'maxQno')
            .where(`cq.class = '${req.classId}' AND cq.subject = '${req.subject}'`)
            .getRawOne();
        return res.maxQno || 0;
    }


}